import { Controller } from '@hotwired/stimulus';

/*
Plugin del botón de marcar / desmarcar todos los checks.
Si pasan puedeSeleccionarBusqueda = true indica que a parte de seleccionar todos
los checks visibles, se seleccionan todos los registros de la búsqueda aunque no
estén los checks en pantalla. Se usa para en listados paginados, poder indicar que
se seeleccionan todos los registros de la búsqueda, no solo la página actual
*/
// FIXME: Hay muchos métodos que ahora están en GestorSeleccionListado. Este componente debería
// de utilizar esa clase para llamar a los métodos comunes y quitar la duplicidad de aquí
export default class SeleccionarTodo extends Controller {
  connect() {
    this.input = this.element.querySelector('input');
    this.icono = this.element.querySelector('i');
    // TODO: Desconectar
    this.element.addEventListener('click', (event) => this.marcar(event));

    this.config = { ...this.element.dataset };
    this.busquedaCompletaMarcada = false;
  }

  marcar(event) {
    event.preventDefault();
    const checks = this.#getCheckboxes();
    const checksMarcados = checks.filter((c) => c.checked);
    let marcar = true;
    // Si están todos marcados
    if (checks.length === checksMarcados.length) {
      if (this.config.puedeSeleccionarBusqueda) {
        marcar = this.#gestionarBusquedaCompleta(checks);
      } else {
        marcar = false;
      }
    }
    this.#marcarChecks(checks, marcar);
    this.element.dispatchEvent(new Event('change'));
  }

  // Si es la búsqueda completa devuelve undefined, si no hay nada
  // seleccionado devolvería un array vacío.
  getValoresSeleccionados() {
    if (this.busquedaCompletaMarcada) {
      return undefined;
    }

    const checks = this.#getCheckboxes().filter((c) => c.checked);
    return checks.map((c) => c.value);
  }

  // Parametros para enviar al servidor y usarlos de modo más o menos estandard
  getParametrosFiltros() {
    return {
      search_token: document.querySelector(this.config.searchTokenSelector || '.search_token').value,
      busqueda_completa: this.busquedaCompletaMarcada,
      ids: this.getValoresSeleccionados(),
    };
  }

  #gestionarBusquedaCompleta(checks) {
    if (!this.busquedaCompletaMarcada) {
      // Ya estaba marcada
      this.clasesOriginales = this.icono.getAttribute('class');
      this.icono.setAttribute('class', 'fa fa-check-double');
      const title = 'Seleccionados todos los registros buscados';

      this.icono.setAttribute('title', title);

      checks.forEach((check) => {
        check.disabled = true;
        check.dataset.busquedaCompleta = true;
      });
    } else {
      this.icono.setAttribute('class', this.clasesOriginales);
      this.icono.setAttribute('title', '');

      checks.forEach((check) => {
        if (check.dataset.busquedaCompleta) {
          check.disabled = false;
        }
      });
    }
    this.busquedaCompletaMarcada = !this.busquedaCompletaMarcada;
    return this.busquedaCompletaMarcada;
  }

  // eslint-disable-next-line class-methods-use-this
  #marcarChecks(checks, marcar) {
    checks.forEach((check) => {
      check.checked = marcar;
      // Bubbles true es para que propague el evento, si no no funciona
      // cuando se cazan los eventos usando useEventDelegation el método
      // on('change',hijos', ...) de jquery.
      // https://stackoverflow.com/questions/51581421/dispatchevent-change-on-select-element-cannot-be-handled-by-delegate
      check.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  #getWrapper() {
    if (this.config.wrapper) {
      return document.querySelector(this.config.wrapper);
    }
    return this.element.closest('table');
  }

  #getCheckboxes() {
    const selectorChecks = this.config.selectorChecks || 'input[type=checkbox]';
    return [...this.#getWrapper().querySelectorAll(selectorChecks)].filter((check) => {
      if (check.disabled && !check.dataset.busquedaCompleta) {
        return false;
      }
      return true;
    });
  }
}
